import * as mongoose from 'mongoose'
import { InspectionStatus, ProductFlag, SubVertical } from 'common/constants'
import { isPcEnv } from 'common/utils/common'
import { Channel, getSubVertical } from './channel'
import { Attribute } from './sub/attribute'
import { Tag, Image, getRepresentativeImage, AnimationGif, Certification } from './sub'
import { Product } from '../api/product'
import { getSubVerticalPath } from 'common/constants/verticalService'
import { ArrayUtils } from '@shopping/common'
import { WindowReview } from 'common/types/entities/mongo/review'

export interface WindowProduct extends mongoose.Document {
  _id: string
  productNo: string
  name: string
  displayCategory: string[]
  productCategory: string[]
  goods?: string
  contentText?: string
  modelNumber?: string
  npay?: boolean
  best?: boolean
  flag?: ProductFlag
  viewCount?: number
  viewCountFromWindowApi?: number
  zzimCount?: number
  satisfactionPercent?: number // deprecated 예정
  salePrice: number
  pcDiscountPrice?: number
  mobileDiscountPrice?: number
  recentSaleCount?: number
  totalSaleCount?: number
  totalReviewCount?: number
  soldout: boolean
  inspectionStatus: InspectionStatus
  channel: Channel
  exposure?: boolean
  talkPay?: boolean
  presentContent?: string
  images?: Image[]
  barcodeImage?: Image
  saleStartAt?: Date
  saleEndAt?: Date
  brand?: {
    _id: string
    name: string
    logoImageUrl?: string
  }
  attributes?: Attribute[]
  tags?: Tag[]
  createdAt?: Date
  updatedAt?: Date
  martUpdatedAt?: Date
  inspectedAt?: Date
  isNewItem?: boolean
  groupKey?: number
  rank?: number
  popularScore?: number
  productDisplayCategoryId?: string
  pcDiscountRate?: number
  mobileDiscountRate?: number
  nvMid: number
  matNvMid?: number
  manufactureDate?: Date
  averageReviewScore?: number
  stockQuantity?: number
  isMyZzim?: boolean
  isViewBrand?: boolean
  clickedByImageCoordinate?: boolean
  menus?: string[]
  representativeVideoInfo: AnimationGif
  visibleRepresentativeVideo?: boolean
  reviewId?: string
  certifications?: Certification[]
  representativeReview?: WindowReview
}

export const getDisplayImage = (product: WindowProduct): Image => {
  return getRepresentativeImage(product.images)
}

export const getDiscountPrice = (product: Product): number => {
  return (
    (isPcEnv ? product.benefitsView.discountedSalePrice : product.benefitsView.mobileDiscountedSalePrice) ||
    product.salePrice
  )
}

export const getWindowDiscountPrice = (product: WindowProduct): number => {
  return (isPcEnv ? product.pcDiscountPrice : product.mobileDiscountPrice) || product.salePrice
}

export const getLinkUrl = (product: WindowProduct): string => {
  if (!product) {
    return null
  }
  return `${getSubVerticalPath(getSubVertical(product.channel))}/stores/${product.channel._id}/products/${product._id}`
}

export const AnimationGifSubVerticals = [
  SubVertical.STYLE,
  SubVertical.DIRECT_FARM,
  SubVertical.LOCAL_FOOD,
  SubVertical.STATIONERY,
]
export const MAX_GIF_IMAGE_COUNT = 3

export const getVisibleGifProducts = (products: WindowProduct[], subVertical: SubVertical): WindowProduct[] => {
  if (ArrayUtils.isEmpty(products) && AnimationGifSubVerticals.indexOf(subVertical) < 0) {
    return products
  }
  const gifIndexes = []
  products.forEach((product, idx) => {
    if (
      product.representativeVideoInfo &&
      product.representativeVideoInfo.gifThumbnailUrl &&
      (!product.hasOwnProperty('visibleRepresentativeVideo') || product.visibleRepresentativeVideo)
    ) {
      gifIndexes.push(idx)
    }
  })
  if (gifIndexes.length > MAX_GIF_IMAGE_COUNT) {
    const shuffledIdxes = ArrayUtils.shuffle(gifIndexes)
    const visibleIdexes = shuffledIdxes.slice(0, MAX_GIF_IMAGE_COUNT)
    const inVisibleIdexes = shuffledIdxes.slice(MAX_GIF_IMAGE_COUNT)
    return products.map((originProduct, idx) => {
      const product = Object.assign({}, originProduct)
      if (visibleIdexes.indexOf(idx) > -1) {
        product.visibleRepresentativeVideo = true
      } else if (inVisibleIdexes.indexOf(idx) > -1) {
        product.visibleRepresentativeVideo = false
      }
      return product
    })
  }
  return products
}

export const getHasVisibleGif = (product: WindowProduct, subVertical: SubVertical) => {
  return (
    AnimationGifSubVerticals.indexOf(subVertical) > -1 &&
    product.representativeVideoInfo &&
    product.representativeVideoInfo.gifThumbnailUrl &&
    (!product.hasOwnProperty('visibleRepresentativeVideo') || product.visibleRepresentativeVideo)
  )
}
